import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FadeIn, MaskedLines } from "@/components/motion";

export default function CtaSection() {
  return (
    <section className="px-5 pb-24 md:px-8 md:pb-32" data-testid="cta-section">
      <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-brand px-6 py-16 md:px-16 md:py-24">
        <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-white/5" />
        <div className="pointer-events-none absolute -bottom-32 -left-16 h-80 w-80 rounded-full bg-sage/10" />
        <div className="relative">
          <FadeIn y={12}>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-sage-light">
              Talk it through first
            </p>
          </FadeIn>
          <MaskedLines
            as="h2"
            onView
            delay={0.1}
            className="mt-6 font-serif text-3xl tracking-tight text-white sm:text-4xl lg:text-5xl"
            lines={[
              "Understand your options",
              <span key="l2">
                before you <span className="italic text-sage-light">decide</span> anything.
              </span>,
            ]}
          />
          <FadeIn delay={0.35}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-white/80">
              A conversation with a care coordinator is free, unhurried, and
              carries no obligation. Share your reports, ask hard questions, and
              decide only when you are ready.
            </p>
          </FadeIn>
          <FadeIn delay={0.5} className="mt-10 flex flex-wrap gap-4">
            <Button
              asChild
              className="h-12 rounded-full bg-white px-7 font-semibold text-brand transition-colors duration-300 hover:bg-sage-light"
            >
              <Link to="/contact" data-testid="cta-section-primary">
                Speak with a Care Coordinator
              </Link>
            </Button>
            <Button
              asChild
              variant="outline"
              className="h-12 rounded-full border-white/40 bg-transparent px-7 font-semibold text-white transition-colors duration-300 hover:bg-white/10 hover:text-white"
            >
              <Link to="/contact" data-testid="cta-section-secondary">
                Request a Treatment Estimate
              </Link>
            </Button>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
